import { render } from "./DetaliiUtilizator.vue?vue&type=template&id=95bd2c1e&scoped=true"
import script from "./DetaliiUtilizator.vue?vue&type=script&lang=js"
export * from "./DetaliiUtilizator.vue?vue&type=script&lang=js"

import "./DetaliiUtilizator.vue?vue&type=style&index=0&id=95bd2c1e&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95bd2c1e"]])

export default __exports__